import { connect } from 'react-redux';
import { chatListSubscribe } from '../../ChatV2/redux/actions';
import { getChatListChats, getChatListSubscriptionStatus, isChatReduxReady, } from '../../ChatV2/redux/selectors';
import { getIsLoggedIn } from '../../publicSession/selectors';
var mapStateToProps = function (state) {
    var _a;
    return ({
        chats: (_a = getChatListChats(state)) !== null && _a !== void 0 ? _a : [],
        chatReduxReady: isChatReduxReady(state),
        chatListSubscriptionStatus: getChatListSubscriptionStatus(state),
        isLoggedIn: getIsLoggedIn(state),
    });
};
var mapDispatchToProps = {
    subscribeToChatList: chatListSubscribe,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=DesktopSharePopup.container.js.map